import SelectDynamicTagsModal from './SelectDynamicTagsModal';

export default SelectDynamicTagsModal;
